import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { scrollToSection } from "@/components/Navbar";

const services = [
  {
    num: "01",
    title: "Residential Cleaning",
    desc: "Regular cleaning to keep your home fresh and tidy — kitchens, baths, floors and every corner in between, on a schedule that fits your life.",
    img: "https://images.unsplash.com/photo-1724582586529-62622e50c0b3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBtaW5pbWFsaXN0JTIwbGl2aW5nJTIwcm9vbSUyMGJyaWdodHxlbnwwfHx8fDE3ODc1ODg3ODl8MA&ixlib=rb-4.1.0&q=85",
    alt: "A spotless bright living room after a residential clean",
  },
  {
    num: "02",
    title: "STR & Airbnb Turnovers",
    desc: "Fast, meticulous turnovers and deep cleans that create 5-star experiences for your guests — linens, restaging and photo-ready finishes between every stay.",
    img: "https://images.pexels.com/photos/545034/pexels-photo-545034.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "A neutral, hotel-crisp bedroom prepared for short-term rental guests",
  },
  {
    num: "03",
    title: "Commercial Cleaning",
    desc: "Customized cleaning solutions for offices, retail spaces and other commercial properties — a workplace that feels as professional as you are.",
    img: "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1200&q=80",
    alt: "A clean, modern office space",
  },
  {
    num: "04",
    title: "Deep Cleaning",
    desc: "Detailed top-to-bottom cleaning for a deeper, refreshed clean — baseboards, fixtures, appliances and all the places regular cleans don't reach.",
    img: "https://images.pexels.com/photos/34794673/pexels-photo-34794673.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "A pristine white kitchen after a deep clean",
  },
  {
    num: "05",
    title: "Move-In / Move-Out",
    desc: "Make your move stress-free with a spotless space — whether you're handing over the keys or opening the door to your next chapter.",
    img: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1200&q=80",
    alt: "A bright, empty home ready for move-in",
  },
];

export default function Services() {
  return (
    <section id="services" className="py-28 md:py-36" data-testid="services-section">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <Reveal>
          <p className="text-[11px] md:text-xs uppercase tracking-[0.28em] text-seateal font-medium">
            What we do
          </p>
          <h2 className="mt-5 font-display font-light tracking-tighter leading-none text-4xl md:text-6xl text-pine max-w-2xl">
            Every space,{" "}
            <span className="font-editorial italic font-semibold text-seateal">sparkling.</span>
          </h2>
        </Reveal>

        <div className="mt-20 md:mt-24">
          {services.map((s, i) => (
            <Reveal key={s.num} delay={0.05}>
              <div
                className={`group grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-center border-t border-border/70 py-14 md:py-16 ${
                  i === services.length - 1 ? "border-b" : ""
                }`}
                data-testid={`service-chapter-${s.num}`}
              >
                <div className="md:col-span-2">
                  <span className="font-editorial italic font-medium text-5xl md:text-6xl text-foamdeep/80 leading-none transition-colors duration-500 group-hover:text-seateal">
                    {s.num}
                  </span>
                </div>
                <div className="md:col-span-4">
                  <h3 className="font-display font-medium tracking-tight text-2xl md:text-[1.7rem] text-pine">
                    {s.title}
                  </h3>
                  <p className="mt-4 text-sm md:text-base font-light leading-relaxed text-pine/65">
                    {s.desc}
                  </p>
                  <button
                    onClick={() => scrollToSection("#contact")}
                    className="mt-6 inline-flex items-center gap-1.5 text-sm font-normal text-seateal hover:text-pine transition-colors duration-300"
                    data-testid={`service-quote-link-${s.num}`}
                  >
                    Request this clean
                    <ArrowUpRight
                      size={15}
                      strokeWidth={1.75}
                      className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                    />
                  </button>
                </div>
                <div className="md:col-span-6">
                  <div className="rounded-2xl overflow-hidden aspect-[16/10] shadow-[0_16px_50px_rgba(2,44,34,0.08)]">
                    <img
                      src={s.img}
                      alt={s.alt}
                      loading="lazy"
                      className="w-full h-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-[1.06]"
                    />
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
